import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { TextControl } from '@wordpress/components';
import { useEntityProp } from '@wordpress/core-data';
import { __ } from '@wordpress/i18n';
export default function NavigationMenuNameControl() {
  const [title, updateTitle] = useEntityProp('postType', 'wp_navigation', 'title');
  return createElement(TextControl, {
    label: __('Menu name'),
    value: title,
    onChange: updateTitle
  });
}
//# sourceMappingURL=navigation-menu-name-control.js.map